export const lenisRef = { current: null };

export const scrollToHash = (hash) => {
  const el = document.querySelector(hash);
  if (!el) return;
  if (lenisRef.current) lenisRef.current.scrollTo(el, { offset: -72, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const EASE = [0.16, 1, 0.3, 1];
